import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const CostForm_VariableCost_Foau_Mutation = graphql(`
  mutation CostForm_VariableCost_Foau(
    $filter: IdFilterInput!
    $update: VariableCostInput!
    $versionData: VersionDataInput
  ) {
    findOneAndUpdateVariableCost(
      filter: $filter
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type VariableCost_Foau_Result = ResultOf<
  typeof CostForm_VariableCost_Foau_Mutation
>;

export const useUpdateVariableCostMutation = () =>
  useGraphQLMutation(CostForm_VariableCost_Foau_Mutation);
